import React from 'react';

export default function CampaignList({
  campaigns,
  onOpen,
  scope = 'current',
  onScopeChange,
  currentSiteId = null,
  currentSiteName = '',
  showHeader = true,
}) {
  const maxVisibleCampaigns = 5;
  const shouldScroll = campaigns.length > maxVisibleCampaigns;
  const canToggleScope = typeof onScopeChange === 'function';
  const emptyState = scope === 'accessible'
    ? 'No campaigns found across accessible sites yet.'
    : currentSiteName
      ? `No campaigns yet for ${currentSiteName}.`
      : 'No campaigns yet.';

  return (
    <div className="mb-6">
      {showHeader ? (
        <div className="mb-3 flex items-center justify-between">
          <div>
            <h2 className="text-lg font-semibold text-white">Saved Campaigns</h2>
            <div className="text-xs text-gray-400">
              Newest first. Site ownership is shown on each campaign.
            </div>
          </div>
          <div className="flex items-center gap-3">
            {canToggleScope && (
              <div className="flex items-center rounded border border-gray-700 bg-gray-900 p-1 text-xs text-gray-300">
                <button
                  type="button"
                  className={`rounded px-2 py-1 ${scope === 'current' ? 'bg-indigo-600 text-white' : 'text-gray-300'}`}
                  onClick={() => onScopeChange('current')}
                >
                  Current Site
                </button>
                <button
                  type="button"
                  className={`rounded px-2 py-1 ${scope === 'accessible' ? 'bg-indigo-600 text-white' : 'text-gray-300'}`}
                  onClick={() => onScopeChange('accessible')}
                >
                  All Accessible Sites
                </button>
              </div>
            )}
            <span className="text-xs uppercase tracking-wide text-gray-400">
              {campaigns.length} total
            </span>
          </div>
        </div>
      ) : null}
      {scope === 'accessible' && (
        <div className="mb-3 rounded border border-cyan-900/60 bg-cyan-950/20 px-3 py-2 text-xs text-cyan-50/85">
          Campaigns from other sites are visible here for discovery. Use the main site selector before opening a campaign owned by another site.
        </div>
      )}
      <div className={shouldScroll ? 'max-h-[420px] overflow-y-auto pr-1' : ''}>
        {campaigns.map((c) => (
          <div key={c.id} className="flex justify-between items-center gap-3 bg-gray-900 p-3 rounded mb-2 text-white">
            <div className="min-w-0">
              <div className="truncate font-medium">{c.title}</div>
              <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-gray-400">
                <span className="rounded-full border border-gray-700 bg-gray-950 px-2 py-1 text-gray-200">
                  {c.siteName || 'Unknown site'}
                </span>
                {c.landingKey ? <span className="truncate">/lp/c/{c.landingKey}</span> : null}
              </div>
            </div>
            <button
              className="px-2 py-1 bg-indigo-600 text-xs rounded text-white disabled:bg-gray-700 disabled:text-gray-400"
              onClick={() => onOpen(c)}
              disabled={Boolean(currentSiteId) && String(c.siteId || '') !== String(currentSiteId)}
              title={
                Boolean(currentSiteId) && String(c.siteId || '') !== String(currentSiteId)
                  ? `Switch the main site selector to ${c.siteName || 'the owning site'} before opening this campaign.`
                  : ''
              }
            >
              {Boolean(currentSiteId) && String(c.siteId || '') !== String(currentSiteId) ? 'Switch Site' : 'Open'}
            </button>
          </div>
        ))}
        {campaigns.length === 0 && (
          <div className="text-gray-400">{emptyState}</div>
        )}
      </div>
    </div>
  );
}
